
import menuUploadFileSelector from "../../components/menu/menu-upload-file-selector.vue";
import menuUploadSteppers from "../../components/menu/menu-upload-steppers.vue";
import menuUploadHeader from "../../components/menu/menu-upload-header.vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import MenuUploadUnassignedImageWarningDialog from "../../components/dialogs/menu-upload-unassigned-image-warning-dialog.vue";
import MenuUploadDescriptionWarningDialog from "../../components/dialogs/menu-upload-description-warning-dialog.vue";
import MenuUploadCharacterLimitDialog from "../../components/dialogs/menu-upload-character-limit-dialog.vue";
import ConfirmationDialog from "../../components/dialogs/confirmation-dialog.vue";
import MenuUploadPriceMissingDialog from "../../components/dialogs/menu-upload-price-missing-dialog.vue";
import MenuUploadSettingUpScreen from "../../components/menu/menu-upload-setting-up-screen.vue";
import MenuUploadInfoDialog from "../../components/dialogs/menu-upload-info-dialog.vue";
const foapsDataFields = [
  // {
  //   value: "category-name",
  //   text: "Category Name",
  //   type: "String",
  //   required: false
  // },
  // {
  //   value: "subcategory-name",
  //   text: "Subcategory Name",
  //   type: "String",
  //   required: false
  // },
  {
    value: "item_name",
    text: "Item Name",
    type: "String",
    required: true
  },
  // {
  //   value: "variant_name",
  //   text: "Variant Name",
  //   type: "String",
  //   required: false
  // },
  {
    value: "price",
    text: "Price",
    type: "Number",
    required: true
  }
];
export default {
  components: {
    menuUploadVerifyItems: () =>
      import("@/components/menu/menu-upload-verify-items.vue"),
    menuUploadMappingStep: () =>
      import("@/components/menu/menu-upload-mapping-step.vue"),
    menuUploadConfigureCharges: () =>
      import("@/components/menu/menu-upload-configure-charges.vue"),
    menuUploadCarousel: () =>
      import("@/components/menu/menu-upload-carousel.vue"),
    multiSelectionGrid: () =>
      import("@/components/menu/multi-selection-grid.vue"),
    menuUploadGrid: () => import("@/components/menu/menu-upload-grid.vue"),
    menuUploadFileSelector,
    menuUploadHeader,
    menuUploadSteppers,
    MenuUploadUnassignedImageWarningDialog,
    MenuUploadDescriptionWarningDialog,
    MenuUploadCharacterLimitDialog,
    ConfirmationDialog,
    MenuUploadPriceMissingDialog,
    MenuUploadSettingUpScreen,
    MenuUploadInfoDialog
  },

  data() {
    return {
      showUnassignedImageWarningDialog: false,
      showUnassignedDescriptionWarningDialog: false,
      currentStep: "",
      showCharacterLimitDialog: false,
      showMissingPackagingChargesDialog: false,
      showItemsWithMissingPriceDialog: false,
      selectedItem: null,
      showDeleteConfirmationDialog: false,
      showMenuSettingUpScreen: false,
      menuUploadProgress: 0,
      showRouteLeaveConfirmation: false,
      targetRoute: null,
      hasUnsavedChanges: true,
      showMandatoryAssignDialog: false,
      showMappingValidationDialog: false
    };
  },
  computed: {
    ...mapState("menu", [
      "menuUploadRawData",
      "categories",
      "tags",
      "taxes",
      "menuUploadCurrentStep",
      "menuUploadList",
      "menuUploadInvalidList",
      "menuUploadDuplicateList",
      "menuUploadMissingNameList",
      "menuUploadExceededCharLimitList",
      "menuUploadImageList"
    ]),
    ...mapGetters("restaurant", [
      "getAllBrands",
      "getLocationChannels",
      "hasMultipleBrands"
    ]),
    ...mapGetters("menu", [
      "getMenuUploadListGroupByCategory",
      "getItemsWithoutPrice",
      "getItemsWithMandatoryButUnassignedDescriptions"
    ]),
    ...mapState("restaurant", ["printers", "locationDetails"]),
    itemsWithoutPackageCharge() {
      return this.menuUploadList.filter((item) => !item.package_charge);
    },
    getUnassignedItemCount() {
      return this.menuUploadList.filter(
        (el) => !el[this.currentStepItem.property]
      ).length;
    },
    steps() {
      let steps = [
        {
          id: "mapping-step",
          label: "Menu Mapping",
          component: "menu-upload-mapping-step",
          attributes: foapsDataFields,
          class: "ma-8"
        },
        {
          id: "verify-items",
          label: "Imported Items",
          component: "menu-upload-verify-items",
          class: ""
        },
        {
          id: "configure-charges",
          label: "Configure Charges",
          component: "menu-upload-configure-charges",
          class: ""
        },
        {
          id: "dish-type",
          label: "Set Dish Type",
          component: "menu-upload-carousel",
          attributes: this.$constants.dishTypes.DISH_TYPES.map((el) => ({
            id: el.value,
            name: el.label,
            color: el.color
          })),
          class: "",
          property: "dish_type"
        },
        {
          id: "set-category",
          label: "Set Category",
          component: "menu-upload-carousel",
          attributes: JSON.parse(JSON.stringify(this.categories))
            .sort((a, b) => a.id - b.id) // Sort cloned categories by id
            .map((el) => ({
              id: el.id,
              name: el.category_name,
              subAttributes: el.subcategories
                ?.map((sub) => ({
                  id: sub.id,
                  name: sub.subcategory_name
                }))
                .sort((a, b) => a.id - b.id) // Sort subcategories by id
            })),
          class: "",
          property: "category_id",
          subProperty: "sub_category_id"
        },
        {
          id: "set-tag",
          label: "Set Tags",
          component: "multi-selection-grid",
          attributes: this.tags?.map((el) => ({
            id: el.id,
            name: el.name
          })),
          class: "",
          property: "tags"
        },
        {
          id: "set-tax",
          label: "Set Tax",
          component: "multi-selection-grid",
          attributes: this.taxes?.map((el) => ({
            id: el.id,
            name: el.tax_name
          })),
          class: "",
          property: "zomato_tax_id"
        },
        // {
        //   id: "assign-platform",
        //   label: this.hasMultipleBrands ? "Assign Brands" : "Set Channels",
        //   component: "multi-selection-grid",
        //   attributes: this.getAllBrands?.reduce((list, el) => {
        //     const elPlatforms = el.restaurant_platforms.map((item) => ({
        //       id: item.id,
        //       name: this.getChannelConstObj(item.platform_name).label
        //     }));
        //     return [...list, ...elPlatforms];
        //   }, []),
        //   group: this.hasMultipleBrands
        //     ? this.getAllBrands.map((el) => ({
        //         id: el.id,
        //         name: el.name,
        //         colspan: el.restaurant_platforms?.length
        //       }))
        //     : [],
        //   class: "",
        //   property: "platform_ids",
        //   showBorders: this.hasMultipleBrands
        // },

        // {
        //   id: "set-kot-group",
        //   label: "Assign KOT",
        //   component: "menu-upload-carousel",
        //   attributes: this.printers.map((el) => ({
        //     id: el.id,
        //     name: el.nickname || el.name
        //   })),
        //   class: "",
        //   property: "printer_id"
        // },

        // { id: "set-batch", label: "Set Batch" },

        {
          id: "add-photos",
          label: "Upload Images",
          component: "menu-upload-grid",
          attributes: this.getMenuUploadListGroupByCategory,
          class: ""
        },
        {
          id: "add-description",
          label: "Add Description",
          component: "menu-upload-grid",
          attributes: this.getMenuUploadListGroupByCategory,
          class: ""
        },
        {
          id: "set-addons",
          label: "Set Add-ons",
          component: "menu-upload-grid",
          attributes: this.getMenuUploadListGroupByCategory,
          class: ""
        },
        {
          id: "set-choices",
          label: "Set Choices",
          component: "menu-upload-grid",
          attributes: this.getMenuUploadListGroupByCategory,
          class: ""
        }
      ];
      return steps;
    },
    currentStepItem() {
      return this.steps[this.menuUploadCurrentStep];
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.locationDetails.id) {
      next();
      return false;
    }
    if (this.hasUnsavedChanges && this.menuUploadRawData.length) {
      // Show confirmation dialog
      this.showRouteLeaveConfirmation = true;

      // Save the target route
      this.targetRoute = to;
      // Prevent immediate navigation
      next(false);
    } else {
      // Proceed with navigation
      next();
    }
  },
  beforeMount() {
    this.getCategories();
    this.getTaxes();
    this.getTags();
    this.getAddons();
    this.getLocationPrinters({ id: this.locationDetails.id });
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },

  methods: {
    ...mapActions("menu", [
      "getCategories",
      "getTaxes",
      "getTags",
      "getAddons",
      "getMenuList",
      "menuBulkUpload",
      "resetFilters",
      "updateMenuUploadConfigureChargesFilters",
      "uploadImage",
      "resetMenuBulkUploadStore"
    ]),
    ...mapActions("restaurant", ["getLocationPrinters"]),
    ...mapMutations("menu", [
      "SET_MENU_UPLOAD_CURRENT_STEP",
      "SET_MENU_UPLOAD_RAW_DATA",
      "SET_MENU_UPLOAD_LIST",
      "SET_MENU_UPLOAD_INVALID_LIST",
      "SET_MENU_UPLOAD_DUPLICATE_LIST",
      "SET_MENU_UPLOAD_MISSING_NAME_LIST",
      "SET_MENU_UPLOAD_EXCEEDED_CHAR_LIMIT_LIST",
      "REMOVE_UNASSIGNED_IMAGES",
      "ADD_UPLOADED_IMAGE_URL_TO_MENU_LIST",
      "SET_MENU_ITEMS",
      "SET_MENU_UPLOAD_IMAGES"
    ]),

    goToStep(step) {
      if (this.currentStepItem?.id === "mapping-step") {
        this.findInvalidItems();
      }
      this.SET_MENU_UPLOAD_CURRENT_STEP(step);
    },

    findInvalidItems() {
      let validItems = [],
        invalidItems = [],
        duplicateItems = [],
        missingNameItems = [];

      // Track seen item names to identify duplicates
      let itemNameTracker = new Set();
      this.menuUploadList.forEach((el, index) => {
        // Check for missing item name
        if (!el.item_name) {
          missingNameItems.push(el);
          invalidItems.push(el);
          return;
        }

        // Check for duplicate entries
        if (itemNameTracker.has(el.item_name)) {
          duplicateItems.push(el);
          invalidItems.push(el);
          return;
        } else {
          itemNameTracker.add(el.item_name);
        }

        // Handle missing item price
        if (!el.item_price) {
          el.item_price = null;
        }

        // Add valid item to the list
        validItems.push(el);
      });

      this.SET_MENU_UPLOAD_LIST(validItems);
      this.SET_MENU_UPLOAD_INVALID_LIST(invalidItems);
      this.SET_MENU_UPLOAD_DUPLICATE_LIST(duplicateItems);
      this.SET_MENU_UPLOAD_MISSING_NAME_LIST(missingNameItems);
      this.findExceededCharLimitItems();
    },
    findExceededCharLimitItems() {
      let exceededCharLimitItems = [];
      this.menuUploadList.forEach((el, index) => {
        // Check for item name exceeding character limit
        if (el.item_name?.length > 70) {
          exceededCharLimitItems.push(el);
        }
      });
      this.SET_MENU_UPLOAD_EXCEEDED_CHAR_LIMIT_LIST(exceededCharLimitItems);
    },
    async handleMenuBulkUpload() {
      this.menuUploadProgress = 0;
      this.showMenuSettingUpScreen = true;
      try {
        for (const el of this.menuUploadImageList) {
          const formData = new FormData();
          formData.append("item_image", el.image);
          formData.append(
            "transformation",
            JSON.stringify([
              { height: 400, width: 400, crop: "fill", gravity: "auto" }
            ])
          );
          try {
            const { data } = await this.uploadImage(formData);
            if (data?.status === "success") {
              this.ADD_UPLOADED_IMAGE_URL_TO_MENU_LIST({
                itemId: el.itemId,
                image: data?.data
              });
            } else {
              this.$nuxt.$emit("show-error-toast", data.message);
            }
            this.menuUploadProgress += 1;
          } catch (error) {
            console.log(error);
          }
        }
        const payloadItems = [];
        const channels =
          this.locationDetails.restaurants[0].restaurant_platforms;
        const channelIds = channels.map((channel) => channel.id);
        this.menuUploadList.forEach((el) => {
          const item = {};
          item.item_name = el.item_name;
          item.description = el.description;
          item.dish_type = el.dish_type;
          item.category_id = el.category_id;
          item.sub_category_id = el.sub_category_id || null;
          item.price = el.variants?.length ? null : el.price;
          item.package_charge = el.package_charge || null;
          item.platform_ids = channelIds;
          item.tags = el.tags;
          item.zomato_tax_id = el.zomato_tax_id;
          item.image = el.image || null;
          item.variants = el.variants?.length ? el.variants : null;
          item.addons = el.addons?.length
            ? el.addons.map((addon) => {
                return {
                  name: addon.groupName,
                  max: addon.maxSelection,
                  min: addon.minSelection,
                  ids: addon.selectedItems
                };
              })
            : null;
          item.choices = el.choices?.length
            ? el.choices.map((choice) => {
                return {
                  name: choice.groupName,
                  max: choice.maxSelection,
                  min: choice.minSelection,
                  items: choice.selectedItems.map((item) => {
                    return {
                      name: item.item_name,
                      price: item.item_unit_price
                    };
                  })
                };
              })
            : null;
          payloadItems.push(item);
        });
        await this.menuBulkUpload(payloadItems);
        this.menuUploadProgress += 1;
        this.SET_MENU_ITEMS([]);
        await this.sleep(2000);
        this.menuUploadProgress += 1;
        await this.sleep(2000);
        this.$nuxt.$emit("show-toast", {
          text: "Menu uploaded successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.cancelImport();
      } catch (error) {
        console.error(error);
        this.$nuxt.$emit("show-error-toast", error);
      }
    },
    cancelImport() {
      this.resetMenuBulkUploadStore();
      this.$router.back();
    },
    handleProceedToNextStep() {
      this.REMOVE_UNASSIGNED_IMAGES();
      this.goToStep(this.currentStep);
      this.resetFilters();
      this.showUnassignedImageWarningDialog = false;
    },
    handleUnassignedDialogOpen({ step, unassignedPhotoCount }) {
      this.currentStep = step;
      this.unassignedPhotoCount = unassignedPhotoCount;
      this.showUnassignedImageWarningDialog = true;
    },
    handleShowMandatoryAssignDialog() {
      this.showMandatoryAssignDialog = true;
    },
    handleShowDescriptionWarningDialog() {
      this.showUnassignedDescriptionWarningDialog = true;
    },

    handleShowCharacterLimitDialog() {
      this.showCharacterLimitDialog = true;
    },
    handleProceedWithMissingPackagingCharges() {
      this.showMissingPackagingChargesDialog = false;
      if (this.getItemsWithoutPrice.length) {
        this.showItemsWithMissingPriceDialog = true;
        return;
      }
      this.goToStep(this.menuUploadCurrentStep + 1);
    },
    handleViewItemsWithMissingPackagingCharges() {
      const filter = {
        withVariants: false,
        withoutVariants: false,
        withPackagingCharges: false,
        withoutPackagingCharges: true
      };
      this.updateMenuUploadConfigureChargesFilters(filter);
      this.showMissingPackagingChargesDialog = false;
    },
    handleShowConfirmationDialog(item) {
      this.selectedItem = item;
      this.showItemsWithMissingPriceDialog = false;

      this.showDeleteConfirmationDialog = true;
    },
    deleteSelected() {
      if (this.selectedItem) {
        const index = this.getMenuUploadItemIndex(
          this.menuUploadList,
          this.selectedItem.id
        );

        if (index !== -1) {
          let menuUploadList = JSON.parse(JSON.stringify(this.menuUploadList));
          menuUploadList.splice(index, 1);
          this.SET_MENU_UPLOAD_LIST(menuUploadList);
        }
        this.showDeleteConfirmationDialog = false;
        this.selectedItem = null;
        if (this.getItemsWithoutPrice.length) {
          this.showItemsWithMissingPriceDialog = true;
        }
      }
    },
    handlePriceMissingDialogSubmit() {
      this.showItemsWithMissingPriceDialog = false;
      this.goToStep(this.menuUploadCurrentStep + 1);
    },

    handleProceedAndDiscard() {
      this.resetMenuBulkUploadStore();
      this.showRouteLeaveConfirmation = false;
      this.hasUnsavedChanges = false;
      this.$router.push(this.targetRoute);
    },
    handleBeforeUnload(event) {
      if (!this.locationDetails.id) return false;
      const message = "Are you sure you want to leave?";
      event.preventDefault();
      event.returnValue = message;
      return message;
    }
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  }
};
